import { Component, Input } from '@angular/core';
import { Message } from '../../../models';

@Component({
    selector: 'message-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent {
  @Input('message') message!: Message;

  constructor() {}
}
